import './EventListSectionHeader.scss'

import { FilterableListContext } from '@react/FilterableList/FilterableListContext'
import { useContext } from 'react'

type EventListSectionHeaderPropsType = {
  label: string
}

export const EventListSectionHeader = ({ label }: EventListSectionHeaderPropsType) => {
  const { propsState, translationsState } = useContext(FilterableListContext)
  const HeadingTag = (propsState.seoHeadingElement || 'h4') as keyof JSX.IntrinsicElements
  let headerLabel: string

  switch (label) {
    case 'onDemand':
      headerLabel = translationsState.onDemandLabel
      break

    case 'unscheduled':
      headerLabel = translationsState.unscheduledEventsLabel
      break

    default:
      headerLabel = label.replace('-', ' ')
      break
  }

  return (
    <HeadingTag id={headerLabel} className={'cmp-filterable-list__section-header cmp-title__text h4'}>
      {headerLabel}
    </HeadingTag>
  )
}
